import React, { useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { isMuted, setMuted } from '../../utils/sound';

// Klein knopje om geluidsfeedback aan/uit te zetten (voorkeur blijft bewaard).
export const SoundToggle: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [muted, set] = useState(isMuted());
  const flip = () => { setMuted(!muted); set(!muted); };
  return (
    <button
      onClick={flip}
      title={muted ? 'Geluid aanzetten' : 'Geluid uitzetten'}
      aria-label={muted ? 'Geluid aanzetten' : 'Geluid uitzetten'}
      className={`inline-flex items-center justify-center rounded-tile border border-hairline bg-surface text-sub hover:text-ink transition-colors ${className}`.trim()}
      style={{ width: 36, height: 36 }}
    >
      {muted ? <VolumeX className="w-4 h-4" strokeWidth={1.75} /> : <Volume2 className="w-4 h-4" strokeWidth={1.75} />}
    </button>
  );
};
